<template>
  <div
    class="th-card th-card-hover th-hover-pointer card-course-transaction-container"
  >
    <div
      class="flex flex-col lg:flex-row justify-start lg:justify-between px-4"
    >
      <div class="flex mb-2 lg:mb-0">
        <p class="date th-font-weight-normal">
          {{ parsingDate(transactionData.createdAt) }}
        </p>
        <va-badge :type="statusTransaction().type">{{
          statusTransaction().description
        }}</va-badge>
      </div>
      <div class="lg:block text-xs text-gray-600">
        {{ transactionData.external_id }}
      </div>
    </div>
    <div class="flex flex-col lg:flex-row gap-6 py-8 px-4">
      <div class="w-full lg:w-3/5 border-b lg:border-b-0 lg:border-r">
        <div
          v-for="(course, idx) in transactionData.transactionDetails"
          :key="idx"
          class="mb-4"
        >
          <div class="flex flex-col sm:flex-row sm:items-center gap-2 md:gap-4">
            <img
              class="sm:w-18 sm:h-16 rounded-md object-cover"
              :src="
                course.courseId.thumbnailSmall
                  ? backendUrl + course.courseId.thumbnailSmall
                  : course.courseId.thumbnail
                  ? backendUrl + course.courseId.thumbnail
                  : '/img/thumbnail/empty.png'
              "
              :alt="course.courseName"
            />
            <div class="">
              <div class="text-lg font-bold">{{ course.courseName }}</div>
              <p>{{ thousandPrice(course.coursePrice) }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full lg:w-2/5 self-center">
        <p class="th-font-gray-3">Total Harga:</p>
        <h4 class="price">{{ thousandPrice(transactionData.totalPrice) }}</h4>
      </div>
    </div>
    <div class="footer">
      <!-- <p class="th-text-primary">Lihat Detil Transaksi</p> -->
      <va-modal :backdrop-clickable="false" ref="modalInvoice">
        <div slot="header" />
        <div slot="body" class="p-4">
          <Invoice :invoiceData="transactionData" />
        </div>
        <div slot="footer" class="p-4">
          <div style="text-align: right">
            <va-button @click="$refs.modalInvoice.close()">Tutup</va-button>
          </div>
        </div>
      </va-modal>
      <va-button
        @click="ctaTransaction"
        v-if="statusTransaction().type !== 'danger'"
        :type="statusTransaction().type === 'warning' ? 'warning' : 'primary'"
        >{{
          statusTransaction().type === "warning"
            ? "Bayar Sekarang"
            : "Lihat Invoice"
        }}</va-button
      >
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import thousandPrice from '@/helpers/thousandPrice'
const Invoice = () => import('@/components/Shared/Invoice')

export default {
  props: {
    transactionData: {
      type: Object,
      required: true,
    },
  },
  components: {
    Invoice,
  },
  data() {
    return {
      moment,
      thousandPrice,
      backendUrl: process.env.VUE_APP_BACKEND_URL,
    }
  },
  // mounted() {
  //   this.$refs.modalInvoice.open()
  // },
  methods: {
    ctaTransaction() {
      if (this.transactionData.status === 'pending') {
        window.open(this.transactionData.xenditUrl, '_blank')
      } else if (this.transactionData.status === 'success') {
        this.$refs.modalInvoice.open()
      }
    },
    parsingDate(transactionDate) {
      const fullDate = new Date(transactionDate)
      const parsedFullDate = fullDate.toISOString().substring(0, 10)
      const parsedDate = moment(parsedFullDate).locale('id').format('DD MMMM YYYY')
      return parsedDate
    },
    statusTransaction() {
      let status = {
        type: '',
        description: '',
      }
      if (this.transactionData.status === 'success') {
        status = {
          type: 'success',
          description: 'Selesai',
        }
      } else if (this.transactionData.status === 'pending') {
        status = {
          type: 'warning',
          description: 'Menunggu Pembayaran',
        }
      } else if (this.transactionData.status === 'cancel') {
        status = {
          type: 'danger',
          description: 'Dibatalkan',
        }
      }
      return status
    },
  },
}
</script>

<style lang="scss">
.card-course-transaction-container {
  padding: 1rem 0;
  width: 100%;
  .header {
    padding: 0 1rem;
    // border-bottom: 1px solid var(--kit-border);
    .flex {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }

  .content {
    padding: 0 1rem;
    margin-top: 25px !important;
    display: flex;
    align-items: center;
    .left {
      width: 60%;
      padding: 0 !important;
      box-sizing: border-box;

      .list-course {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 12px;
        margin-bottom: 16px;
        img {
          object-fit: cover;
          border-radius: 4px;
        }
      }
    }

    .right {
      width: 40%;
      // padding: 0!important;

      .price {
        margin-top: 6px !important;
      }
    }
  }

  .footer {
    padding: 0 1rem;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    text-align: right;
    // border-top: 1px solid var(--kit-border);
  }
}
</style>
